import React from 'react';
import {WizardField} from '../../../components/Wizard/QuestionWrapper';
import {ActionType} from '../../../components/AutoForm/AutoFieldNew';
import {ReviewDetailsFragment} from '../../../schema-types/ReviewDetailsFragment';
import {precursorAndHeaderFieldsType} from './precursorFields';
import {skippingAnnualReview} from './reviewAction';
import {AccountBasicFragment} from '../../../schema-types/AccountBasicFragment';
import {GetAllPadAdvisers_allPadAdvisers} from '../../../schema-types/GetAllPadAdvisers';

const padFields = (
  reviewDetails: ReviewDetailsFragment | undefined,
  account?: AccountBasicFragment | undefined,
  allPadAdvisers?: GetAllPadAdvisers_allPadAdvisers[]
): WizardField<precursorAndHeaderFieldsType>[] => {
  const fields: WizardField<precursorAndHeaderFieldsType>[] = [];
  if (account?.propositionType?.includes('Select') && allPadAdvisers) {
    const adviserOptions = allPadAdvisers.map((adviser) => ({
      label: adviser.name || 'Unknown Adviser',
      value: adviser.id,
    }));

    fields.push({
      id: 'reviewAdviser',
      title: 'Review Adviser',
      question: 'Please select the adviser for the review.',
      questionComponent: (
        <>
          <ul>
            <li>Please select the adviser for the review</li>
            <li>This value will not be able to be updated post precursor completion</li>
          </ul>
        </>
      ),
      label: 'Select Adviser',
      enabled: (values: any) => {
        const isSkipping = skippingAnnualReview(
          values as precursorAndHeaderFieldsType,
          reviewDetails
        );
        return !isSkipping;
      },
      type: ActionType.selectAutocomplete,
      options: adviserOptions,
      initialValue: reviewDetails?.adviser?.id || undefined,
      canBeEmpty: false,
      requireSubmit: true,
      validation: (val: any) => {
        if (!val) {
          return 'Please select an adviser';
        }
        return undefined;
      },
    });
  }
  return fields;
};
export default padFields;
